export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.isOpenImageModal = payload.isOpenImageModal
  newState.index = payload.index
  newState.positionChild = payload.positionChild !== undefined ? payload.positionChild : ''
  return newState;
};
